(ns frontend.ui.component.lp-portal.report.body.real-estate.pdf.view.tearsheet
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.column.pdf.view :as columns]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]))

(defn- tearsheet-page-left
  [{:keys [tvpi return-development]}]
  (card/card
   "Return development"
   {:stack [{:svg   (chart-view/chart-svg "highcharts"
                                          (potpuri/deep-merge
                                           (:figures tvpi)
                                           {:chart {:width  500
                                                    :height 350}}))
             :width 250}
            (text-content/optional-footer tvpi
                                          {:margin-top    4
                                           :margin-bottom 6})
            (table/tearsheet-table {:rows (:figures return-development)})
            (text-content/optional-footer return-development {:margin-top 10})]}))

(defn- tearsheet-page-center
  [{:keys [largest-investment-by-nav
           portfolio-locations]}]

  (concat [(when-not (:hide? largest-investment-by-nav)
             (card/card
              "Largest investments - Property by NAV"
              {:svg   (chart-view/chart-svg "highcharts"
                                            (potpuri/deep-merge (:figures largest-investment-by-nav)
                                                                {:chart {:width  500
                                                                         :height 350}}))
               :width 250}
              (text-content/optional-footer largest-investment-by-nav)))]
          [(card/card
            "Locations"
            {:svg   (chart-view/geomap-svg "highcharts"
                                           (potpuri/deep-merge
                                            (:figures portfolio-locations)
                                            {:chart {:width  500
                                                     :height 350}}))
             :width 250}
            (text-content/optional-footer portfolio-locations))]))

(defn- tearsheet-page-right
  [{:keys [basic-information-primary basic-information-secondary]}]
  (let [primary (:figures basic-information-primary)
        secondary (:figures basic-information-secondary)]
    (card/card
     "Basic information"
     (table/dynamic-stack primary)
     (table/dynamic-stack secondary)
     (text-content/optional-footer basic-information-primary {:margin-top 6})
     (text-content/optional-footer basic-information-secondary))))

(defn tearsheet-page
  [report-data]
  (let [tearsheet-data (:tearsheet report-data)]
    (page/page
     (page/second-column-background)
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Tear sheet" :toc-item true})
     (columns/columns
      (tearsheet-page-left tearsheet-data)
      (tearsheet-page-center tearsheet-data)
      (tearsheet-page-right tearsheet-data)))))

(defn tearsheet-page-stockholm-living
  [report-data]
  (let [tearsheet-data (:tearsheet report-data)]
    (page/page
     (page/second-column-background-half-page)
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Tear sheet" :toc-item true})
     (columns/columns
      (tearsheet-page-left tearsheet-data)
      (tearsheet-page-right tearsheet-data)))))
